import { render, staticRenderFns } from "./app-ios.vue?vue&type=template&id=055f786c&scoped=true"
import script from "./app-ios.vue?vue&type=script&lang=js"
export * from "./app-ios.vue?vue&type=script&lang=js"
import style0 from "./app-ios.vue?vue&type=style&index=0&id=055f786c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "055f786c",
  null
  
)

export default component.exports